export default {
    'aboutSeller' : 'о продавце',
    'aboutProduct' : 'о товаре',
    'aboutUs' : 'О нас',
    'aboutAgrolink' : 'О AGROLINK',
    'absent': 'отсутствует',
    'accountDeleted' : 'Аккаунт заблокирован. Свяжитесь с администрацией для уточнения деталей.',
    'actionRequireLogin' : 'Для совершения этого действия авторизуйтесь пожалуйста',
    'activateError' : 'Ошибка активации аккаунта. Свяжитесь с администрацией.',
    'activeIngredient' : 'Действующее вещество',
    'actualBudget' : 'Фактический бюджет',
    'add' : 'Добавить',
    'addCondition' : 'Добавить условие',
    'addContract' : 'Добавить договор',
    'addCulture' : 'Добавить еще культуру',
    'addMore' : 'Добавить еще',
    'address' : 'Адрес',
    'addressDelivery' : 'Адрес доставки',
    'addressFact' : 'Факт. Адрес',
    'addressLaw' : 'Юр. Адрес',
    'addFeedback' : 'Добавить отзыв',
    'addSellerFeedback' : 'Добавить отзыв о продавце',
    'addToBasket' : 'Добавить в корзину',
    'addToBasketSuccess' : 'успешно добавлено в корзину',
    'addToOften' : 'Добавить в частые',
    'addingProduct' : 'Добавить товар',
    'addFile' : 'Прикрепить файл',
    'addProductError' : 'Ошибка при добавлении товара',
    'addProductSuccess' : 'Товар успешно добавлен',
    'agrarianReceipt' : 'Аграрная расписка',
    'agrolinkManager' : 'Менеджер Агролинк',
    'and' : 'и',
    'alreadyInBasket' : 'Уже в корзине',
    'alreadyHaveAccount' : 'Уже есть аккаунт ?',
    'alreadyRegistered' : 'Уже зарегистрированы?',
    'all' : 'Все',
    'allAvailableProductsOnTheMarket' : 'Все доступные товары на рынке',
    'allProductsNotCompleted' : 'Все товары не оформились',
    'apply' : 'Применить',
    'archive' : 'Архив',
    'articleNumber' : 'Артикул',
    'authChecking' : 'Проверка авторизации',
    'avatarDeleted' : 'Аватар удален',
    'avatarSettings' : 'Настройка аватара',
    'arriveDate' : 'Дата доставки',
    'asSoonPossible' : 'Как можно скорее',
    'attach' : 'Прикрепить',
    'back' : 'Назад',
    'backToOrders' : 'Вернуться к заказам',
    'bankName' : 'Название банка',
    'bankMfo' : 'МФО',
    'bankAccount' : 'Расчетный счет',
    'balance' : 'Остаток',
    'balancePart' : 'Предоплатная часть',
    'basket' : 'Корзина',
    'basketEmpty' : 'Ваша корзина пуста',
    'before' : 'До',
    'begin' : 'Начать',
    'billOfExchange' : 'Авалированный вексель',
    'budget' : 'Бюджет',
    'buyer' : 'Покупатель',
    'buyerRegistration' : 'Регистрация для покупок',
    'buyerRegWelcomeMessage' : 'Зарегистрируйтесь, чтоб начать покупать напрямую у поставщиков',
    'changeStatus' : 'Изменить статус',
    'buy' : 'Купить',
    'buyAgrolink' : 'Оформить через Agrolink',
    'buyAllSellers' : 'Оформить всех продавцов',
    'buyAll' : 'Оформить все',
    'buyWithProduct' : 'С этим товаром покупают',
    'byDate' : 'По дате',
    'byPriceMin' : 'По цене (сначала дешевые)',
    'byPriceMax' : 'По цене (сначала дорогие)',
    'byRating' : 'По рейтингу',
    'byRecommendation' : 'По рекомендации',
    'byRequest' : 'По запросу',
    'byViews' : 'По просмотрам',
    'cancel' : 'Отмена',
    'cancelFilters' : 'Скинуть',
    'calculator' : 'Калькулятор',
    'calculating' : 'Расчет',
    'calculationResult' : 'Результат калькуляции',
    'calculateTheCost' : 'Рассчитать стоимость',
    'calculatorStep1stHeader' : 'Введите пожалуйста информацию ниже и мы предложим оптимальные варианты защиты для поля. Всего три шага и индивидуальная тех-карта готова!',
    'calculatorStep2ndHeader' : 'Пожалуйста, выберите кол-во фаз обработки вашего поля и типы препаратов, которые собираетесь использовать.',
    'calculatorStep3rdHeader' : 'Теперь для ваших фаз обработки и типов препаратов укажите проблематику и бюджет на 1 гектар. Так Агролинк сможет подобрать наиболее точные варианты продуктов.',
    'calculatorStep4thHeader' : 'Ура! На Агролинк есть результаты по вашим параметрам. Выберите один из списка чтобы препарат учелся в бюджете.',
    'category' : 'Категория',
    'catalog' : 'Каталог',
    'categories' : 'Категории',
    'characteristics' : 'Характеристики',
    'change' : 'Изменить',
    'changesSaved' : 'Изменения сохранены',
    'changesSavedError' : 'Ошибка при сохранении данных',
    'cheap' : 'Дешевые',
    'checkout' : 'Оформить',
    'checkoutInBasket' : 'Оформить в корзине',
    'checkoutProduct' : 'Оформить  товар',
    'checkoutProducts' : 'Оформить  товары',
    'chemicalClass' : 'Химический класс',
    'choose' : 'Выбрать',
    'chooseContract' : 'Выбрать договор',
    'chooseOneOption' : 'Выберите один из вариантов',
    'chooseProblemsDrugTypes' : 'Выберите проблематику для типов препаратов',
    'chooseTypesOfDrug' : 'Выберите один или несколько типов препарата',
    'chooseVariants' : 'Выберите варианты',
    'codeEgrpou' : 'Код ЕГРПОУ',
    'comments' : 'Комментарии',
    'commonBudgetOnHectare' : 'Общий бюджет обработки гектара',
    'commonCost' : 'Общая стоимость',
    'companyInfo' : 'Информация о компании',
    'contract' : 'Договор',
    'contractAdded' : 'Договор добавлен',
    'contactUs' : 'Связаться с нами',
    'city' : 'Город',
    'close' : 'Закрыть',
    'collapse' : 'Свернуть',
    'companies' : 'Компании',
    'company' : 'Компания',
    'companyDescriptionRu' : 'Описание компании на русском',
    'companyDescriptionUa' : 'Описание компании на украинском',
    'companyName' : 'Название компании',
    'companyNameRu' : 'Название компании на русском',
    'companyNameUa' : 'Название компании на украинском',
    'companyRepresentatives' : 'Представители компании',
    'companyLogo' : 'Лого компании',
    'compare' : 'Сравнить',
    'compareProducts' : 'Сравнить продукты',
    'commercialPolicy' : 'Коммерческая политика',
    'commercialPolicies' : 'Политика скидок',
    'commentAboutCompany' : 'Оставьте комментарий о продукте',
    'commission': "Комиссия Liqpay",
    'condition' : 'Условие',
    'contact' : 'Контакт',
    'contactName' : 'Название контакта',
    'contacts' : 'Контакты',
    'contactsManager' : 'Контактные лица',
    'contactPerson' : 'Контактное лицо',
    'contactsInfo' : 'Контактная информация',
    'continueShopping' : 'Продолжить закупки',
    'contractual' : 'Договорная',
    'confirm' : 'Подтвердить',
    'confirmOrder' : 'Подтвердить оформление',
    'costPerHectare' : 'Затраты на 1 гектар',
    'credit' : 'Кредит',
    'creditPart' : 'Кредитная часть',
    'credentialsPassword' : 'Установите пароль',
    'credentialsWithEmail' : 'Установите пароль и email',
    'currency' : 'Валюта',
    'culture' : 'Культура',
    'customAttributesNames' : {
        'kultura' : 'Культура и норма использования',
    },
    'dataErrorUpdated' : 'Ошибка при обновлении данных',
    'dataSuccessUpdated' : 'Данные успешно обновлены',
    'date' : 'Дата',
    'dateFrom' : 'дата от',
    'dateTo' : 'дата до',
    'delivery' : 'Доставка',
    'deliveryDate' : 'Дата доставки',
    'delete' : 'Удалить',
    'deleteAvatar' : 'Удалить аватар',
    'deliveryToAnywhere' : 'Доставка в любую точку',
    'department' : 'Отдел',
    'deselectAll' : 'Отменить выделение',
    'description' : 'Описание',
    'descriptionRu' : 'Описание товара на Русском',
    'descriptionUa' : 'Описание товара на Украинском',
    'details' : 'Детали',
    'dimensions' : 'Габариты',
    'discount' : 'Скидка',
    'discountByCommercialPolicy' : 'Скидка по комм. политике',
    'discountInPercent' : 'Скидка в %',
    'diseases' : 'Заболевания',
    'distributorRegions' : 'Регионы продавца',
    'downloadPresentation' : 'Скачать презентацию',
    'doYouWantToDeleteSale' : 'Вы действительно хотите отказаться от продажи?',
    'doYouWantToDeleteBought' : 'Вы действительно хотите отказаться от закупки?',
    'drugEffectOnProblem' : 'Действие препарата на проблему',
    'edit' : 'Редактировать',
    'edprou' : 'ЄДРПОУ',
    'enter' : 'Войти',
    'enterBudget' : 'Введите бюджет',
    'enterRate' : 'Введите желаемую норму',
    'enters' : 'Войдите',
    'emailInvalid' : 'Введите корректный email',
    'emailRequired' : 'Укажите email',
    'emptyBasket' : 'В Вашей корзине пока нет товаров',
    'enterWithHelp' : 'Войти c помощью',
    'existence' : 'Наявність',
    'exit' : 'Выход',
    'exit?' : 'Выйти ?',
    'expensive' : 'Дорогие',
    'factoryDirectPriceWithoutSpeculation' : 'Прямая цена от производителя без спекуляций',
    'favorites' : 'Избранное',
    'farmziBenefits' : 'Преимущества Агролинк',
    'faqDialogTitle' : 'Заполните пожалуйста краткую форму и мы свяжемся с Вами в ближайшее время',
    'feedback' : 'Обратная связь',
    'feedbackOne' : 'Отзыв',
    'feedbackMore' : 'Отзывы',
    'feedbacks' : 'Отзывов',
    'feedbackAboutCompany' : 'Отзывы о компании',
    'feedbackSend' : 'Отзыв отправлен',
    'fertilizers' : 'Удобрения',
    'firstName' : 'Имя',
    'firstTimeAtFarmzi' : 'Впервые на AGROLINK?',
    'filterBy' : 'Фильтр по',
    'filter' : 'Фильтр',
    'filters' : 'Фильтры',
    'filterTo' : 'Фильтровать',
    'financeAndConfirmation' : 'Финансы и подтверждение',
    'for' : 'за',
    'forAgriculturalProducer' : 'Для агрария',
    'forFarmer' : 'Для фермера',
    'forCompany' : 'Для компании',
    'forPhase' : 'для фазы',
    'forSeller' : 'Для продавца',
    'forgetPassword' : 'Забыли пароль',
    'forManufacturer' : 'Для производителя',
    'from' : 'с',
    'fromOt' : 'От',
    'fromCompany' : 'от компании',
    'fromSeller' : 'от продавца',
    'freeRegistration' : 'Бесплатная регистрация',
    'freeShipping' : 'Бесплатная доставка',
    'fundsWillBeRefunded' : 'После отмены средства будут возвращены',
    'generalInfo' : 'Общая информация',
    'getStartedAtFarmzi' : 'Начните работать на AGROLINK',
    'goTo' : 'Перейти',
    'goToCalculator' : 'Перейти в Калькулятор',
    'height' : 'Высота',
    'hello' : 'Здравствуйте',
    'help' : 'Помощь',
    'helpfulInfo' : 'Полезная информация',
    'helpCenter' : 'Справочный центр',
    'history': 'История',
    'howToBuy' : 'Как делать закупки на AGROLINK',
    'howToSell' : 'Как продавать на AGROLINK',
    'homeBudgetCalculator' : 'Калькулятор бюджета на обработку пестицидами',
    'homeCalculatorSubtitle' : 'Делайте детальный расчет бюджета на пестицидную обработку ваших полей и находите оптимальные альтернативы.',
    'homeCalculatorSubtitle1': 'Делайте детальный расчет бюджета на пестицидную обработку ваших полей за 5 минут. Сначала введите культуру, количество гектар и обработок.',
    'homeCalculatorSubtitle2': 'Укажите бюджет и проблематику с которой нужно бороться. В результате вы получите оптимальные препараты под ваш бюджет, которые максимально подойдут под Ваши потребности',
    'homeHeadTitle' : 'Покупайте товары для поля онлайн с выгодой 5-15% напрямую от поставщиков',
    'homeWhatIs' : 'AGROLINK предлагает фермерам и производителям инструментарий технологий для мониторинга цен, формирования закупки, переговоров, подписания договора покупки и автоматизации повторных закупок',
    'homeFarmersText' : [
        {id: 1, text:'1. Экономия бюджета;'},
        {id: 2, text:'2. Быстрый поиск товаров по важным характеристикам;'},
        {id: 3, text:'3. Сравнение товаров и осознанный выбор;'},
        {id: 4, text:'4. Актуальные цены и наличие;'},
        {id: 5, text:'5. Удобная доставка по всей Украине.'},
    ],
    'homeManufacturersText' : [
        {id: 1, text:'1. Увеличение продаж без выделения дополнительного ресурса компании;'},
        {id: 2, text:'2. Помощь в логистике и операционном документообороте;'},
        {id: 3, text:'3. Поддержка 24/7;'},
        {id: 4, text:'4. Бесплатное размещение на пробный период.'},
    ],
    'howFindUs' : 'Как вы про нас узнали',
    'howPlatformWorks' : 'Как работает онлайн платформа',
    'iAgreeWith' : 'Соглашаюсь c',
    'inBuy' : 'В закупку',
    'inProcess' : 'В процессе',
    'inStock' : 'В наличии',
    'invalidValue' : 'Неверное значение',
    'issue' : 'Оформить',
    'inDevelopment' : 'Находится в разработке',
    'influenceType' : 'Тип влияния',
    'kg' : 'кг',
    'lastEdit' : 'Последнее изменение',
    'lastName' : 'Фамилия',
    'law' : 'Юридическое лицо',
    'lawInfo' : 'Юридическая информация',
    'length' : 'Длина',
    'legalEntityName' : 'Полное название юридического лица',
    'linkCopied' : 'Ссылка скопирована',
    'linkNotCopied' : 'Ссылка не скопирована',
    'loadingPleaseWait' : 'Загрузка... пожалуйста подождите',
    'login' : 'Вход',
    'loginError' : 'Ошибка входа. Свяжитесь с администрацией.',
    'loginWelcomeMessage': 'Вас ожидают сотни товаров',
    'logoAlt' : 'Платформа для поиска агропромышленной продукции',
    'logoTitle' : 'Независимая платформа агропромышленной продукции - Agrolink.com.ua',
    'logout' : 'Выйти',
    'look' : 'Посмотреть',
    'lowLevel': 'Заканчивается',
    'joinToAgrolink' : 'Присоединиться к Агролинк',
    'knowCost' : 'Узнать стоимость',
    'knowExistence' : 'Узнать наличие',
    'knowPrice' : 'Узнать цену',
    'm' : 'м',
    'mainData' : 'Основные данные',
    'mainInfo' : 'Основная информация',
    'mainPage' : 'На главную',
    'makeSellerOrder' : 'Оформить товары этого продавца',
    'manualEntry' : 'Ввести норму вручную',
    'manufacturersSelection' : 'Отбор производителей',
    'manufacturers' : 'Выбирайте товары и покупайте напрямую у производителя',
    'maxSum' : 'Макс. сумма',
    'mayBeSearch' : 'Возможно вы искали',
    'message' : 'Сообщение',
    'messages' : 'Сообщения',
    'messagesToSeller' : 'Сообщение продавцу',
    'messageSent' : 'Сообщение отправлено',
    'messageText' : 'Текст сообщения',
    'minOrder' : 'Мин. заказ',
    'minSum' : 'Мин. сумма',
    'minimumOrder' : 'Минимальный лот продажи',
    'minimumOrderHelp' : 'Мин. заказ будет также отображать кратность. Например, вы продаете 5 л канистры и указали мин заказ 4 канистры. Клиент сможет купить 4, 8, 12, 16  и тд. канистр с шагом +4.',
    'minimumOrderUnit' : 'Минимальный объем поставки',
    'more' : 'Еще',
    'moreDetails' : 'Подробнее',
    'month' : 'Месяц',
    'mostPopularProducts' : 'Самые популярные товары на агролинк',
    'myBasket' : 'Мои закупки',
    'myContracts' : 'Мои договора',
    'myInfo' : 'Моя информация',
    'myProducts' : 'Мои товары',
    'mySales' : 'Мои продажи',
    'myPurchases' : 'Мои Закупки',
    'name' : 'Наименование',
    'nameSurname' : 'ФИО',
    'nameRu' : 'Наименование  на Русском',
    'nameUa' : 'Наименование на Украинском',
    'needHelp' : 'Нужна помощь?',
    'newPurchase' : 'Новая закупка',
    'newsAndBlog' : 'Новости и блог',
    'next' : 'Далее',
    'noEnoughCompareProducts' : 'Пока вы добавили один товар, добавьте еще для сравнения',
    'noData' : 'К сожалению, по выбраным характеристиками товары отсутствуют.',
    'noAccount' : 'Нет аккаунта',
    'noFeedbacks' : 'Отзывов о компании нет, но вы можете стать первым!',
    'noFeedbacksProduct' : 'Отзывов о товаре нет, но вы можете стать первым!',
    'noProblematic' : 'Проблематика не предусмотрена',
    'noProducts' : 'У вас нет товаров в избранном...',
    'norm' : 'Норма',
    'notActivated' : 'Аккаунт не активированный. Проверьте указанный email для активации аккаунта.',
    'notAvailable': 'Нет в наличии',
    'notExistingPage' : 'Неправильно набранный адрес, или такой страницы уже не существует.',
    'notFound' : 'Ничего не найдено',
    'notes': 'Примечания',
    'numberOfDays' : 'Кол-во дней',
    'numberOfMonths' : 'Кол-во месяцев',
    'numberOfHectares' : 'Кол-во гектар',
    'numberOfTreatments' : 'Кол-во обработок',
    'often': 'Частые',
    'oftenSearched': 'Часто ищут',
    'or': 'или',
    'order' : 'Заказ',
    'orderConfirmMessage1' : 'Получение заказа от 5 000 UAH только по паспорту (Закон от 06.12.2019 № 361-IX)',
    'orderConfirmMessage2' : 'Подтверждая заказ, я принимаю условия',
    'orderConfirmMessage3' : 'В заказ включена комиссия платежной системы Liqpay (2.75%) на товары Агролинк.',
    'orderCreating': 'Оформление заказа',
    'orderDate': 'Дата заказа',
    'orderError': 'Ошибка при оформлении товара',
    'orderHasBeenPaid' : 'Этот заказ оплачен',
    'orderLot': 'Единица заказа',
    'orderNumber': 'Номер заказа',
    'orderPrice': 'Сумма заказа',
    'orderProducts': 'Товары',
    'orderRemoveError': 'Ошибка при удалении заказа',
    'orderRemoveSuccess': 'Заказ успешно удален',
    'orderSuccess': 'Заказ успешно оформлен',
    'orderUpdated': 'Заказ изменен',
    'orderUpdatedError': 'Ошибка при изменении заказа',
    'orderValue': 'Объем закупки',
    'otherSellers': 'Другие продавцы',
    'overprice' : 'Превышение бюджета',
    'packedBy': 'Расфасовано по',
    'packing': 'Фасовка',
    'packType': 'Тип упаковки',
    'partners': 'Наши партнеры',
    'passwordRequired': 'Укажите пароль',
    'payInfo': 'Платежная информация',
    'payment': 'Оплата',
    'paymentAndDelivery': 'Оплата и доставка',
    'paymentMethod': 'Метод оплаты',
    'paymentWay': 'Способ оплаты',
    'paymentWaySet': 'Укажите способ оплаты',
    'paymentWayEnterNameAndCode' : 'Введите пожалуйста название и код ЕГРПОУ юридического лица',
    'personalCabinet' : 'Личный кабинет',
    'personalInfo' : 'Личная информация',
    'personalProfile' : 'Личный профиль',
    'personalInfoSettings' : 'Настройки личной информации',
    'phoneInvalid': 'Введите корректный номер телефона',
    'phoneNumber' : 'Номер телефона',
    'pesticides' : 'Пестициды',
    'physical' : 'Физическое лицо',
    'pickPassword' : 'Придумайте пароль',
    'positiveFeedback' : 'Положительных отзыва из',
    'Prepayment' : 'Предоплата',
    'price' : 'Цена',
    'price&quantity': 'Цена и количество',
    'priceFrom' : 'Цена от',
    'priceTo' : 'Цена до',
    'priceAndAvailabilityInformationInTwoClicks' : 'Информация о цене и наличии в 2 клика',
    'priceWithNds' : 'Цена указана с учетом НДС',
    'priceWithoutNds' : 'Цена указана без учета НДС',
    'priceWithDiscount' : 'Цена со скидкой',
    'priceNotSpecified' : 'Стоимость не указана',
    'privacyAccept' : 'Вы должны принять политику конфиденциальности',
    'privacyPolicy' : 'Политика конфиденциальности',
    'prepare' : 'Оформить этого продавца',
    'problems' : 'Проблематика',
    'problemsAndBudget' : 'Проблематика и бюджет',
    'processingHectares' : 'обработки гектара',
    'processingPhases' : 'Фазы обработки',
    'producer' : 'Производитель',
    'productData' : 'Данные товара',
    'productDescription' : 'Описание товара',
    'productEnumDialogMessage' : 'Зеленым цветом выделены проблемы которые лечит',
    'productFavoritesDelete' : 'Товар удален из избранного',
    'productOrder' : 'Оформление товара',
    'productPage' : 'Страница товара',
    'productParams' : 'Характеристики товара',
    'products' : 'Товаров',
    'productsCategories' : 'Категории товаров на Агролинк',
    'productsCount' : 'Всего товаров',
    'productsFound' : 'Товаров найдено',
    'productsManage' : 'Управление товарами',
    'productsToOrder' : 'Товары к оформлению',
    'productsAreNotProm' : 'Товары которых нет на Prom',
    'productUpdating' : 'Редактирование товара',
    'productsWithDiscount' : 'Товары со скидками',
    'productsAreBoughtOnline' : 'Товары, которые покупаются онлайн',
    'productsPurchasedApp' : 'Товары, которые покупаются через заявку',
    'profileHeader' : 'Профиль пользователя',
    'profileSettings' : 'Настройки профиля',
    'promoSale' : 'Акция',
    'provision' : 'Обеспечение',
    'purchaseAmount' : 'Сумма закупки',
    'purchasesAtAgrolink' : 'Закупки на Агролинк',
    'realizationForm': 'Форма реализации',
    'purchasingAtFarmzi' : 'Закупки на AGROLINK это',
    'quantity': 'Количество',
    'quantityCut': 'Кол-во',
    'questionsAndAnswers' : 'Вопросы и ответы',
    'readMore' : 'Читать далее',
    'recommendedAccordingPacking' : 'Реком. заказ соответственно упаковке',
    'recommendedRateByManufacturer' : 'Рекомендованная норма использования от производителя',
    'region': 'Регион',
    'regions': 'Регионы',
    'regionSearch': 'Поиск в регионе',
    'register': 'Зарегистрироваться',
    'registration': 'Регистрация',
    'remove': 'Удалить',
    'results' : 'Результаты',
    'return': 'Вернуть',
    'retailPrice': 'Цена розницы ',
    'resetPassword': 'Сбросить пароль',
    'requiredField': 'Обязательное поле',
    'requiredQuantity': 'Необходимое кол-во',
    'requestPasswordError': 'Ощибка при запросе сброса пароля. Свяжитесь с администрацией.',
    'requestPassword': 'Запросить сброс пароля',
    'rowsPerPage': 'Строк на странице',
    'saleUnit': 'Единица продажи',
    'save': 'Сохранить',
    'savePassword': 'Сохранить пароль',
    'saving' : 'Экономия',
    'section' : 'Раздел',
    'selectAll' : 'Выбрать все',
    'selectAllRegions' : 'Выбрать все регионы',
    'selectDate' : 'Выбрать дату',
    'selectDateDelivery' : 'Выберите дату поставки',
    'selectDrugs' : 'Виберите препарати',
    'selectFile' : 'Выберите файл',
    'selectPaymentMethod' : 'Выберите метод оплаты',
    'selectProductQuantity': 'Виберите количество товара',
    'selectedDrugs' : 'Вибраные препарати',
    'selfShipmentText1' : 'Агролинк сопровождает сделку',
    'selfShipmentText2' : 'Доставка оплачивается получателем',
    'seller' : 'Продавец',
    'sellers' : 'Продавцы',
    'sellersProducts' : 'Товары продавца',
    'sellerInformation' : 'Информация о продавце',
    'sellerRegistration' : 'Продавать на Агролинк',
    'sellerRegWelcomeMessage' : 'Агролинк - это онлайн-платформа для прямого взаимодействия поставщика и агрария. Мы работаем только с производителями и помогаем увеличить объем продаж без выделения дополнительного ресурса.',
    'seeds' : 'Семена',
    'seeMore' : 'посмотреть еще',
    'send' : 'Отправить',
    'set' : 'Установить',
    'setRecommendOrderDate' : 'Укажите рекомендуемую дату поставки',
    'settlement' : 'Населенный пункт',
    'show' : 'Показать',
    'showMore' : 'Показать больше',
    'size' : 'Размер',
    'siteSearch' : 'Поиск',
    'siteSearchBanner' : 'Поиск по ДВ, проблематике, продукту и производителю',
    'sortBy' : 'Сортировать',
    'somethingWentWrongTryAgainLater' : 'Что-то пошло не так. Попробуйте позднее',
    'specification' : 'Спецификация',
    'specifyRateManually' : 'Укажите норму использования вручную',
    'startSelling' : 'Начать продавать на Агролинк',
    'stillQuestions' : 'Остались вопросы?',
    'subCategories' : 'Подкатегории',
    'successfulAddedOften' : 'Успешно добавлено в частые',
    'successfulDeletedOften' : 'Успешно удалено из частых',
    'successfulDeleted' : 'Успешно удалено',
    'sum' : 'Сумма',
    'sumMax' : 'Макс. сумма',
    'sumMin' : 'Мин. сумма',
    'summaryCost': 'Итоговая стоимость',
    'supplier' : 'поставщик',
    'szr' : 'СЗР',
    'targetBudget' : 'Заданный бюджет',
    'telephone' : 'Телефон',
    'thankYouForYourPurchase' : 'Спасибо за оформление закупки',
    'thankYouForAddProduct' : 'Спасибо за добавление товара',
    'thankYouForFeedback' : 'Спасибо за вашу обратную связь',
    'thankYouForFaqMessage' : 'Спасибо за обращение, свяжемся с Вами в ближайшее время',
    'thankYouForSellerRegistration' : 'Cпасибо за заявку на присоединение к сообществу Agrolink! В Agrolink мы сотрудничаем с украинскими и международными брендами, чтобы помочь им увеличивать продажи и развивать свой бизнес. В связи с этим мы уделяем время проверке каждого участника. Мы свяжемся с вами в ближайшее время!',
    'theme' : 'Тема',
    'toBasket' : 'В корзину',
    'toCatalog' : 'В каталог',
    'total' : 'Итого',
    'toPay' : 'К оплате',
    'toPurchase' : 'В закупку',
    'treaty' : 'Договорная',
    'typesDrugsByPhase' : 'Типы препаратов по фазам',
    'uah' : 'ГРН',
    'uploadImage' : 'Загрузить аватар',
    'undefined' : 'Не указано',
    'unitOfMeasure' : 'Ед. измерения',
    'unitWeight' : 'Вес единицы товара',
    'updateOrder' : 'Изменить заказ?',
    'userAgreement' : 'Условия пользования',
    'usersAgreement' : 'Пользовательского соглашения',
    'wantAddOften' : 'Добавить в частые?',
    'view' : 'Вид',
    'viewResults' : 'Показать результаты',
    'wantAddOftenSelected' : 'Добавить выбранные в частые?',
    'wantDeleteOften' : 'Удалить из частых',
    'wantDeleteOrder' : 'Удалить заявку?',
    'wantRemoveAll' : 'Удалить все?',
    'wantRemoveSelected' : 'Удалить отмеченные?',
    'whatIsFarmzi' : 'Что такое AGROLINK?',
    'website' : 'Сайт',
    'weight' : 'Вес упаковки',
    'welcome' : 'Добро пожаловать',
    'wholesaleAgroPurchasingInSmartPhone' : 'Оптовые Агро-Закупки В Смартфоне',
    'wholesalePrice' : 'Цена опта',
    'wholesaleFrom' : 'Опт от',
    'width' : 'Ширина',
    'withNds' : 'С НДС',
    'withoutNds' : 'Без НДС',
    'withPrivacyPolicy' : 'Политикой конфиденциальности',
    'withPrivacyPolicies' : 'Политики конфиденциальности',
    'withUserAgreement' : 'Условиями пользования',
    'withoutDelivery' : 'без доставки',
    'withoutProblems' : 'Без проблематики',
    'write' : 'Написать',
    'writeToSeller' : 'Написать продавцу',
    'writeSellerFeedback' : 'Напишите ваш отзыв',
    'wrongCredentials' : 'Введены неправильные email или пароль',
    'yes' : 'Да',
    'youMayLike' : 'Вам может понравиться',
    'youViewedEarlier' : 'Вы просматривали ранее',
    'yourName' : 'Ваше имя',
    'yourProductSaved' : 'Ваш товар успешно сохранен!',
};
